import React from 'react';
import StatusBadge from './StatusBadge';

const DocumentCard = ({ document, onPublish, onArchive, onDelete, onEdit, onView, onViewHistory }) => {
  const getDocumentTypeLabel = (type) => {
    const labels = {
      terms_of_service: 'Terms of Service',
      privacy_policy: 'Privacy Policy',
      refund_policy: 'Refund Policy',
      cookie_policy: 'Cookie Policy',
    };
    return labels[type] || type;
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <div className="bg-white rounded-2xl shadow-xs border border-gray-200 p-6 hover:border-gray-300 transition-all duration-200">
      <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-6">
        
        {/* Main Document Details */}
        <div className="flex-1 space-y-3">
          
          {/* Header Title & Status */}
          <div className="flex flex-wrap items-center gap-3">
            <h3 className="text-lg font-bold text-gray-900 tracking-tight">{document.title}</h3>
            <StatusBadge status={document.status} />
          </div>
          
          {/* Metadata Badges */}
          <div className="flex flex-wrap items-center gap-2 text-xs font-medium text-gray-600">
            <span className="font-mono font-bold bg-slate-100 text-slate-800 px-2.5 py-1 rounded-md border border-slate-200">
              v{document.version}
            </span>
            <span className="bg-slate-50 text-slate-700 px-2.5 py-1 rounded-md border border-slate-200">
              Type: {getDocumentTypeLabel(document.documentType)}
            </span>
            {document.effectiveDate && (
              <span className="bg-slate-50 text-slate-700 px-2.5 py-1 rounded-md border border-slate-200">
                Effective: {formatDate(document.effectiveDate)}
              </span>
            )}
            <span className="bg-slate-50 text-slate-700 px-2.5 py-1 rounded-md border border-slate-200">
              Updated: {formatDate(document.updatedAt)}
            </span>
          </div>

          {/* Change Log Commentary */}
          {document.changeLog && (
            <p className="text-xs text-gray-600 leading-relaxed bg-slate-50 p-3 rounded-xl border border-slate-100">
              <strong className="font-semibold text-gray-900">Change Log:</strong> {document.changeLog}
            </p>
          )}

          {/* Created By Author */}
          <div className="text-xs text-gray-400 font-medium pt-1">
            Created by: <span className="text-gray-600 font-semibold">{document.createdBy?.name || 'System Admin'}</span>
          </div>

        </div>

        {/* Action Buttons Group */}
        <div className="flex flex-wrap items-center lg:items-start gap-2 pt-2 lg:pt-0 border-t lg:border-t-0 border-gray-100">
          
          <button
            onClick={onView}
            className="px-3 py-1.5 text-xs font-semibold bg-slate-100 hover:bg-slate-200 text-slate-800 rounded-lg transition-colors focus:outline-none"
          >
            View
          </button>
          
          {document.status === 'draft' && (
            <>
              <button
                onClick={onEdit}
                className="px-3 py-1.5 text-xs font-semibold bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border border-indigo-200 rounded-lg transition-colors focus:outline-none"
              >
                Edit
              </button>
              <button
                onClick={onPublish}
                className="px-3 py-1.5 text-xs font-semibold bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border border-emerald-200 rounded-lg transition-colors focus:outline-none"
              >
                Publish
              </button>
              <button
                onClick={onDelete}
                className="px-3 py-1.5 text-xs font-semibold bg-rose-50 hover:bg-rose-100 text-rose-700 border border-rose-200 rounded-lg transition-colors focus:outline-none"
              >
                Delete
              </button>
            </>
          )}

          {document.status === 'published' && (
            <button
              onClick={onArchive}
              className="px-3 py-1.5 text-xs font-semibold bg-amber-50 hover:bg-amber-100 text-amber-800 border border-amber-200 rounded-lg transition-colors focus:outline-none"
            >
              Archive
            </button>
          )}

          <button
            onClick={onViewHistory}
            className="px-3 py-1.5 text-xs font-semibold bg-slate-800 hover:bg-slate-900 text-indigo-300 rounded-lg transition-colors focus:outline-none"
          >
            History
          </button>

        </div>

      </div>
    </div>
  );
};

export default DocumentCard;